/**
 * /embed/banner-slide/$key — preview isolado de um slide do banner da home.
 * Usado nos iframes de /admin/banner (desktop e mobile). Noindex.
 */
import { createFileRoute, notFound } from "@tanstack/react-router";

import { BannerSlideView } from "@/components/home/BannerSlideView";
import { SLIDE_REGISTRY } from "@/components/home/banner-slides";

export const Route = createFileRoute("/embed/banner-slide/$key")({
  head: () => ({
    meta: [
      { title: "Preview do slide do banner" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: EmbedBannerSlidePage,
});

function EmbedBannerSlidePage() {
  const { key } = Route.useParams();
  const slide = SLIDE_REGISTRY[key];
  if (!slide) throw notFound();

  return (
    <div className="relative overflow-hidden bg-white text-white">
      <BannerSlideView slide={slide} className="relative" preview />
    </div>
  );
}
